
import CalendarEventController from "./CalendarEventController";

import DependencyListBuilder from "../../../utility/DependencyListBuilder";

const calendarMonthEventComponentTemplate = require("./CalendarMonthEvent.tpl.html");

const CalendarMonthEventComponent = {
    name: "tbCalendarMonthEvent",
    config: {
        template: calendarMonthEventComponentTemplate,
        bindings: {
            eventData: "=tbEventData",
            editorNavigateFn: "&tbEditorNavigateFn",
            eventSelected: "&tbEventSelected",
            eventTextClass: "@tbEventTextClass"
        },
        controller: CalendarEventController,
        controllerAs: CalendarEventController.controllerAs
    }
};

CalendarMonthEventComponent.dependencies = DependencyListBuilder([
    CalendarEventController.dependencies
]);

export default CalendarMonthEventComponent;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/calendar-event/CalendarMonthEvent.js
// module id = lwGT
// module chunks = 1